export default __webpack_public_path__ + "static/sentinel-banner-performance-3b69b3bb575a9d08c6f88d4f292db8c4.jpg";